<template>
    <div class="page-deliver-detail">
        <div class="pg-breadcrumb">
            <div class="breadcrumb-item em">報表統計</div>
            <div class="breadcrumb-item">出貨明細</div>
        </div>

        <div class="card-block">
            <Form inline class="pg-form-inline">
                <FormItem>
                    <Select size="small" placeholder="提貨櫃點" v-model="form.arrive">
                        <Option :value="item.ReceivingID" v-for="(item, index) in pickAddress"
                                :key="item.ReceivingID">({{item.cainiao_match}}) {{item.ReceivingName}}
                        </Option>
                    </Select>
                </FormItem>

                <FormItem>
                    <Select size="small" placeholder="收件方式" v-model="form.arrive_type">
                        <Option value="1">門店</Option>
                        <Option value="2">智能櫃</Option>
                    </Select>
                </FormItem>
                <FormItem>
                    <Select size="small" placeholder="操作人" v-model="form.admin_id">
                    	<Option :value="item.user_id" v-for="(item, index) in pickAdmin"
                    	        :key="item.user_id">{{item.username}} ({{item.realname}})
                    	</Option>
                    </Select>
                </FormItem>
                <FormItem>
                    <DatePicker class="no-suffix" type="datetime" size="small" :clearable="false"
                                placeholder="珠海倉庫入庫-開始日期" value-format="yyyy-MM-dd hh:mm:ss" style="width: 100%;" :editable="false" v-model="form.start_time"></DatePicker>
                </FormItem>
                <FormItem>-</FormItem>
                <FormItem>
                    <DatePicker class="no-suffix" type="datetime" size="small" :clearable="false"
                                placeholder="珠海倉庫入庫-結束日期" value-format="yyyy-MM-dd hh:mm:ss" style="width: 100%;" :editable="false" v-model="form.end_time"></DatePicker>
                </FormItem>
            </Form>

            <Form inline class="pg-form-inline form-input-wrap">
                <FormItem>
                    <label class="input-label">快遞單號</label>
                    <Input size="small" v-model="form.odd_numbers" @keyup.enter.native="handleSearch()"></Input>
                </FormItem>
                <FormItem>
                    <label class="input-label">客戶名稱</label>
                    <Input size="small" v-model="form.recipient_contacts" @keyup.enter.native="handleSearch()"></Input>
                </FormItem>
                <FormItem>
                    <label class="input-label">客戶電話</label>
                    <Input size="small" v-model="form.phone" @keyup.enter.native="handleSearch()"></Input>
                </FormItem>
                <FormItem>
                    <label class="input-label">袋號</label>
                    <Input size="small" v-model="form.sack_number" @keyup.enter.native="handleSearch()"></Input>
                </FormItem>
                <FormItem>
                    <div class="pg-btn-wrap">
                        <div class="pg-btn style1" @click="handleSearch">搜索</div>
                        <div class="pg-btn style2" @click="handleExport">導出excel</div>
                    </div>
                </FormItem>
            </Form>
        </div>

        <div class="card-block pd-bt">
			<Spin fix class="pg-sub-loading" v-if="isSubmiting">
			    <Icon type="ios-loading" :size="20" class="demo-spin-icon-load"></Icon>
			    <div class="loading-text">Loading</div>
			</Spin>
            <Table size="small"
                   border
				   no-data-text="暫無數據"
                   :columns="table.column"
                   :data="table.data">
            </Table>

            <div class="pg-pagger">
                <Row>
                    <Col span="12" class="pagger-left">
                    <div class="pagger-total">總共{{totalCount}}條記錄</div>
                    <div class="total-info">
                        <!-- <div>總應收金額：{{sum}}</div>
                        <div>實際已簽收金額：{{money}}</div> -->
                    </div>
                    </Col>
                    <Col span="12" class="pagger-right">
                    <div class="pagger-sizer">
                        <span>每頁</span>
                        <Select v-model="curPageSize" size="small" placeholder="數量">
                            <Option :value="10">10</Option>
                            <Option :value="20">20</Option>
                            <Option :value="30">30</Option>
                            <Option :value="40">40</Option>
                            <Option :value="50">50</Option>
                        </Select>
                    </div>

                    <div class="pagger-elevator">
                        <span>跳轉</span>
                        <Input size="small" v-model="pageInput" @on-keyup="handlePageInput"
                               @on-enter="handlePageEnter"/>
                    </div>
                    
                    <Page size="small"
                          :current="pageIndex"
                          :page-size="curPageSize"
                          :total="totalCount"
                          @on-change="handlePageChange">
                    </Page>
                    </Col>
                </Row>
            </div>
        </div>
    </div>
</template>
<script>
	import axios from 'axios';
    export default {
        data() {
            return {
                pageIndex: 1,   //页码
                curPageSize: 10,    //一页数量
                totalCount: 1, //总条数
                money: 0,
                sum: 0,
                pageInput: '',  //输入的页码
                pickAddress: [],    //提貨櫃點
                packageType: [],    //包裹類型
                pickAdmin: [],
                form: {
                    arrive: '',    //提货柜点
                    arrive_type: '',    //收件方式，1门店，2智能柜
                    goods_type: '', //包裹类型
                    start_time: '',
                    end_time: '',
                    recipient_contacts: '', //客户名称
                    phone: '',  //客户手机号
                    odd_numbers: '',    //快递单号
                    sack_number: '',    //袋号
                	admin_id: '',
					status: ''
                },
                isSubmiting: false,
                // isLoading: true,
                exportLink: '', //导出地址
                table: {
                    column: [
                        {
                            title: '客戶名稱',
                            key: 'name',
                            align: 'center',
							sortable: true,
                            minWidth: 130
                        },
                        {
                            title: '客戶電話',
                            key: 'phone',
                            align: 'center',
							sortable: true,
                            minWidth: 120
                        },
                        {
                            title: '品名',
                            key: 'product',
                            align: 'center',
							sortable: true,
                            minWidth: 80
                        },
                        {
                            title: '快遞單號',
                            key: 'orderNo',
                            align: 'center',
							sortable: true,
                            minWidth: 150
                        },
                        {
                            title: '長',
                            key: 'length',
                            align: 'center',
							sortable: true,
                            minWidth: 80
                        },
                        {
                            title: '寬',
                            key: 'width',
                            align: 'center',
							sortable: true,
                            minWidth: 80
                        },
                        {
                            title: '高',
                            key: 'height',
                            align: 'center',
							sortable: true,
                            minWidth: 80
                        },
                        {
                            title: '包裹類型',
                            key: 'packageType',
                            align: 'center',
							sortable: true,
                            minWidth: 180
                        },
                        {
                            title: '實重',
                            key: 'weight',
                            align: 'center',
							sortable: true,
                            minWidth: 100
                        },
                        {
                            title: '體積重',
                            key: 'weight2',
                            align: 'center',
							sortable: true,
                            minWidth: 100
                        },
                        {
                            title: '件數',
                            key: 'count',
                            align: 'center',
							sortable: true,
                            minWidth: 100
                        },
                        {
                            title: '提貨櫃點',
                            key: 'address',
                            align: 'center',
							sortable: true,
                            minWidth: 120
                        },
						{
						    title: '珠海入庫時間',
						    key: 'in_time',
						    align: 'center',
							sortable: true,
						    minWidth: 160
						},
                        {
                            title: '珠海出庫時間',
                            key: 'out_time',
                            align: 'center',
							sortable: true,
                            minWidth: 160
                        },
                        {
                            title: '澳門入倉時間',
                            key: 'macao_originating_time',
                            align: 'center',
							sortable: true,
                            minWidth: 160
                        },
						{
						    title: '澳門出倉時間',
						    key: 'macao_originating_out_time',
						    align: 'center',
							sortable: true,
						    minWidth: 160
						},
                        {
                            title: '門店上架時間',
                            key: 'arrive_time',
                            align: 'center',
							sortable: true,
                            minWidth: 160,
                        },
						{
						    title: '簽收時間',
						    key: 'pick_time',
						    align: 'center',
							sortable: true,
						    minWidth: 160,
						},
                        {
                            title: '合計費用',
                            key: 'totalFee',
                            align: 'center',
                            sortable: true,
                            className: 'demo-table-info-cell-name',
                            minWidth: 80
                        },
						{
						    title: '代收費',
						    key: 'amount',
						    align: 'center',
							sortable: true,
							className: 'demo-table-info-cell-name',
						    minWidth: 80,
						},
                        {
                            title: '到付運費',
                            key: 'fee',
                            align: 'center',
							sortable: true,
							className: 'demo-table-info-cell-name',
                            minWidth: 80,
                        },
                        {
                            title: '加收附加費',
                            key: 'fee2',
                            align: 'center',
							sortable: true,
							className: 'demo-table-info-cell-name',
                            minWidth: 80
                        },
						{
						    title: '超期費',
						    key: 'outtimepay',
						    align: 'center',
							sortable: true,
							className: 'demo-table-info-cell-name',
						    minWidth: 100,
						},
						{
						    title: '立減費',
						    key: 'activity',
						    align: 'center',
							sortable: true,
							className: 'demo-table-info-cell-name',
						    minWidth: 80,
						},
						{
						    title: '會員積分(支付)',
						    key: 'userIntegral',
						    align: 'center',
							sortable: true,
							className: 'demo-table-info-column',
						    minWidth: 80
						},
                        {
                            title: '現金(支付)',
                            key: 'cash',
                            align: 'center',
							sortable: true,
							className: 'demo-table-info-column',
                            minWidth: 80
                        },
                        {
                            title: '澳門通(支付)',
                            key: 'MacauPass',
                            align: 'center',
							sortable: true,
							className: 'demo-table-info-column',
                            minWidth: 80
                        },
                        {
                            title: 'Mpay(支付)',
                            key: 'MacauWallet',
                            align: 'center',
							sortable: true,
							className: 'demo-table-info-column',
                            minWidth: 80
                        },
                        {
                            title: '支付寶(支付)',
                            key: 'Alipay',
                            align: 'center',
							sortable: true,
							className: 'demo-table-info-column',
                            minWidth: 80
                        },
						{
						    title: '中銀POS(支付)',
						    key: 'zyPos',
						    align: 'center',
							sortable: true,
							className: 'demo-table-info-column',
						    minWidth: 80
						},
                        {
                            title: '工商POS(支付)',
                            key: 'icbc',
                            align: 'center',
							sortable: true,
							className: 'demo-table-info-column',
                            minWidth: 80
                        },
						{
						    title: '微信(支付)',
						    key: 'wxpay',
						    align: 'center',
							sortable: true,
							className: 'demo-table-info-column',
						    minWidth: 80,
						},
						{
						    title: '付款情況',
						    key: 'pay_status',
						    align: 'center',
							sortable: true,
						    minWidth: 150
						},
						{
						    title: '備註',
						    key: 'remarks',
						    align: 'center',
							sortable: true,
						    minWidth: 100,
						},
                    ],
                    data: []
                }
            };
        },
        mounted() {
			this.getPickAddress();
			this.getPackageType();
			this.getList();
			this.getPickAdmin();
        },
		watch: {
			curPageSize() {
				this.getList();
			}
		},
        methods: {
			formatDate(datetime)
			{
			    if (!datetime) return '';
			    let dateTime = new Date(datetime);
			    let year = dateTime.getFullYear();
			    let month = dateTime.getMonth() + 1;
			    let date = dateTime.getDate();
			    let hour = dateTime.getHours();
			    let minute = dateTime.getMinutes();
			    let second = dateTime.getSeconds();
				let milliseconds = dateTime.getMilliseconds();
			    return `${this.formatNum(year)}-${this.formatNum(month)}-${this.formatNum(date)} ${this.formatNum(hour)}:${this.formatNum(second)}:${this.formatNum(milliseconds)}`;
			},
			formatNum(num)
			{
			    return num < 10 ? '0' + num : num;
			},
            //提貨櫃點
            getPickAddress() {
                this.$Rq.requestAuth({
                    url: this.$Api.pickAddress,
                    method: 'get',
                    data: {
                        company_id: 0,
                    }
                }).then((res) => {
                    if (res.code == 0) {
                        this.pickAddress = res.data.data.filter(it=>it.company_id != 15);
                    }
                });
            },
            //操作人
            getPickAdmin() {
                this.$Rq.requestAuth({
                    url: this.$Api.pickAdmin,
                    method: 'post'
                }).then((res) => {
                    if (res.code == 0) {
                        this.pickAdmin = res.data.data;
                    }
                });
            },
            //包裹類型
            getPackageType() {
                this.$Rq.requestAuth({
                    url: this.$Api.packageType,
                    method: 'get'
                }).then((res) => {
                    if (res.code == 0) {
                        this.packageType = res.data.data;
                    }
                });
            },
            getList() {
                let form = this.form;
				this.isSubmiting = true;
                // this.isLoading = true;
                this.$Rq.requestAuth({
                    url: this.$Api.scanIn,
                    method: 'get',
                    data: {
                        status: -3,  //0待出库, 1已出库	
                        offset: (this.pageIndex - 1) * this.curPageSize,
                        limit: this.curPageSize,
                        arrive: form.arrive,
                        arrive_type: form.arrive_type,
                        goods_type: form.goods_type,
                        start_time: this.formatDate(form.start_time),
                        end_time: this.formatDate(form.end_time),
                        recipient_contacts: form.recipient_contacts,
                        phone: form.phone,
                        odd_numbers: form.odd_numbers,
                        sack_number: form.sack_number,
            			admin_id: form.admin_id
                    }
                }).then((res) => {
                    // this.isLoading = false;
					this.isSubmiting = false;
                    if (res.code == 0) {
                        let tempArr = [];
                        let resData = res.data.data;
                        for (let i = 0; i < resData.length; i++) {

                            let orderamount_additional_fee;
                            let orderamount_credit;
                            let orderamount_cash;
                            let orderamount_alipay;
                            let orderamount_macaupass;
                            let orderamount_mpay;
                            let orderamount_zyPos;
                            let orderamount_icbc;
                            let orderamount_wxpay;
                            let orderamount_overtime_fee;
                            let order_type;
                            let order_online;
                            
                            if(resData[i].orderamount != null)
                            {
                                order_type = '新';

                                if(resData[i].orderamount.additional_fee == 0 || resData[i].orderamount.additional_fee == null){
                                    orderamount_additional_fee = 0;
                                }else{
                                    orderamount_additional_fee = resData[i].orderamount.additional_fee;
                                }

                                if(resData[i].orderamount.overtime_fee == 0 || resData[i].orderamount.overtime_fee == null){
                                    orderamount_overtime_fee = 0;
                                }else{
                                    orderamount_overtime_fee = resData[i].orderamount.overtime_fee;
                                }

                                if(resData[i].orderamount.order_online == 1){ //積分

                                    order_online = '積分';
                                    
                                    if(resData[i].orderamount.credit == null){
                                        orderamount_credit = Number(resData[i].orderamount.overtime_fee);
                                    }else{
                                        orderamount_credit = Number(resData[i].orderamount.overtime_fee + resData[i].orderamount.credit + resData[i].orderamount.credit_tw);
                                    }

                                    if(resData[i].orderamount.cash > 0){
                                        orderamount_cash = Number(resData[i].orderamount.cash + resData[i].orderamount.overtime_fee);
                                    }else{
                                        orderamount_cash = 0;
                                    }

                                    if(resData[i].orderamount.alipay > 0){
                                        orderamount_alipay = Number(resData[i].orderamount.alipay + resData[i].orderamount.overtime_fee);
                                    }else{
                                        orderamount_alipay = 0;
                                    }

                                    if(resData[i].orderamount.macaupay > 0){
                                        orderamount_macaupass = Number(resData[i].orderamount.macaupay + resData[i].orderamount.overtime_fee);
                                    }else{
                                        orderamount_macaupass = 0;
                                    }

                                    if(resData[i].orderamount.mpay > 0){
                                        orderamount_mpay = Number(resData[i].orderamount.mpay + resData[i].orderamount.overtime_fee);
                                    }else{
                                        orderamount_mpay = 0;
                                    }

                                    if(resData[i].orderamount.boc > 0){
                                        orderamount_zyPos = Number(resData[i].orderamount.boc + resData[i].orderamount.overtime_fee);
                                    }else{
                                        orderamount_zyPos = 0;
                                    }

                                    if(resData[i].orderamount.icbc > 0){
                                        orderamount_icbc = Number(resData[i].orderamount.icbc + resData[i].orderamount.overtime_fee);
                                    }else{
                                        orderamount_icbc = 0;
                                    }

                                    if(resData[i].orderamount.wechat > 0){
                                        orderamount_wxpay = Number(resData[i].orderamount.wechat + resData[i].orderamount.overtime_fee);
                                    }else{
                                        orderamount_wxpay = 0;
                                    }
                                }

                                if(resData[i].orderamount.order_online == 2){ //中銀
                                    
                                    order_online = '中銀';

                                    if(resData[i].orderamount.boc == null){
                                        orderamount_zyPos = Number(resData[i].orderamount.overtime_fee);
                                    }else{
                                        orderamount_zyPos = Number(resData[i].orderamount.overtime_fee + resData[i].orderamount.boc);
                                    }

                                    if(Number(resData[i].orderamount.credit + resData[i].orderamount.credit_tw) > 0){
                                        orderamount_credit = Number(resData[i].orderamount.credit + resData[i].orderamount.credit_tw);
                                    }else{
                                        orderamount_credit = 0;
                                    }

                                    if(resData[i].orderamount.cash > 0){
                                        orderamount_cash = Number(resData[i].orderamount.cash);
                                    }else{
                                        orderamount_cash = 0;
                                    }

                                    if(resData[i].orderamount.alipay > 0){
                                        orderamount_alipay = Number(resData[i].orderamount.alipay);
                                    }else{
                                        orderamount_alipay = 0;
                                    }

                                    if(resData[i].orderamount.macaupay > 0){
                                        orderamount_macaupass = Number(resData[i].orderamount.macaupay);
                                    }else{
                                        orderamount_macaupass = 0;
                                    }

                                    if(resData[i].orderamount.mpay > 0){
                                        orderamount_mpay = Number(resData[i].orderamount.mpay);
                                    }else{
                                        orderamount_mpay = 0;
                                    }

                                    if(resData[i].orderamount.icbc > 0){
                                        orderamount_icbc = Number(resData[i].orderamount.icbc);
                                    }else{
                                        orderamount_icbc = 0;
                                    }

                                    if(resData[i].orderamount.wechat > 0){
                                        orderamount_wxpay = Number(resData[i].orderamount.wechat);
                                    }else{
                                        orderamount_wxpay = 0;
                                    }
                                }

                                if(resData[i].orderamount.order_online == 3){ //工銀

                                    order_online = '工銀';

                                    if(resData[i].orderamount.icbc == null){
                                        orderamount_icbc = Number(resData[i].orderamount.overtime_fee);
                                    }else{
                                        orderamount_icbc = Number(resData[i].orderamount.overtime_fee + resData[i].orderamount.icbc);
                                    }

                                    if(Number(resData[i].orderamount.credit + resData[i].orderamount.credit_tw) > 0){
                                    orderamount_credit = Number(resData[i].orderamount.credit) + Number(resData[i].orderamount.credit_tw);
                                    }else{
                                        orderamount_credit = 0;
                                    }

                                    if(resData[i].orderamount.cash > 0){
                                        orderamount_cash = Number(resData[i].orderamount.cash);
                                    }else{
                                        orderamount_cash = 0;
                                    }

                                    if(resData[i].orderamount.alipay > 0){
                                        orderamount_alipay = Number(resData[i].orderamount.alipay);
                                    }else{
                                        orderamount_alipay = 0;
                                    }

                                    if(resData[i].orderamount.macaupay > 0){
                                        orderamount_macaupass = Number(resData[i].orderamount.macaupay);
                                    }else{
                                        orderamount_macaupass = 0;
                                    }

                                    if(resData[i].orderamount.mpay > 0){
                                        orderamount_mpay = Number(resData[i].orderamount.mpay);
                                    }else{
                                        orderamount_mpay = 0;
                                    }

                                    if(resData[i].orderamount.boc > 0){
                                        orderamount_zyPos = Number(resData[i].orderamount.boc);
                                    }else{
                                        orderamount_zyPos = 0;
                                    }

                                    if(resData[i].orderamount.wechat > 0){
                                        orderamount_wxpay = Number(resData[i].orderamount.wechat);
                                    }else{
                                        orderamount_wxpay = 0;
                                    }
                                }

                                if(resData[i].orderamount.order_online == 4){ //微信

                                    order_online = '微信';

                                    if(resData[i].orderamount.wechat == null){
                                        orderamount_wxpay = Number(resData[i].orderamount.overtime_fee);
                                    }else{
                                        orderamount_wxpay = Number(resData[i].orderamount.overtime_fee + resData[i].orderamount.wechat);
                                    }

                                    if(Number(resData[i].orderamount.credit + resData[i].orderamount.credit_tw) > 0){
                                    orderamount_credit = Number(resData[i].orderamount.credit) + Number(resData[i].orderamount.credit_tw);
                                    }else{
                                        orderamount_credit = 0;
                                    }

                                    if(resData[i].orderamount.cash > 0){
                                        orderamount_cash = Number(resData[i].orderamount.cash);
                                    }else{
                                        orderamount_cash = 0;
                                    }

                                    if(resData[i].orderamount.alipay > 0){
                                        orderamount_alipay = Number(resData[i].orderamount.alipay);
                                    }else{
                                        orderamount_alipay = 0;
                                    }

                                    if(resData[i].orderamount.macaupay > 0){
                                        orderamount_macaupass = Number(resData[i].orderamount.macaupay);
                                    }else{
                                        orderamount_macaupass = 0;
                                    }

                                    if(resData[i].orderamount.mpay > 0){
                                        orderamount_mpay = Number(resData[i].orderamount.mpay);
                                    }else{
                                        orderamount_mpay = 0;
                                    }

                                    if(resData[i].orderamount.boc > 0){
                                        orderamount_zyPos = Number(resData[i].orderamount.boc);
                                    }else{
                                        orderamount_zyPos = 0;
                                    }

                                    if(resData[i].orderamount.icbc > 0){
                                        orderamount_icbc = Number(resData[i].orderamount.icbc);
                                    }else{
                                        orderamount_icbc = 0;
                                    }
                                }

                                if(resData[i].orderamount.order_online == 5){ //Mpay

                                    order_online = 'Mpay';

                                    if(resData[i].orderamount.mpay == null){
                                        orderamount_mpay = Number(resData[i].orderamount.overtime_fee);
                                    }else{
                                        orderamount_mpay = Number(resData[i].orderamount.overtime_fee + resData[i].orderamount.mpay);
                                    }

                                    if(Number(resData[i].orderamount.credit + resData[i].orderamount.credit_tw) > 0){
                                    orderamount_credit = Number(resData[i].orderamount.credit) + Number(resData[i].orderamount.credit_tw);
                                    }else{
                                        orderamount_credit = 0;
                                    }

                                    if(resData[i].orderamount.cash > 0){
                                        orderamount_cash = Number(resData[i].orderamount.cash);
                                    }else{
                                        orderamount_cash = 0;
                                    }

                                    if(resData[i].orderamount.alipay > 0){
                                        orderamount_alipay = Number(resData[i].orderamount.alipay);
                                    }else{
                                        orderamount_alipay = 0;
                                    }

                                    if(resData[i].orderamount.macaupay > 0){
                                        orderamount_macaupass = Number(resData[i].orderamount.macaupay);
                                    }else{
                                        orderamount_macaupass = 0;
                                    }

                                    if(resData[i].orderamount.boc > 0){
                                        orderamount_zyPos = Number(resData[i].orderamount.boc);
                                    }else{
                                        orderamount_zyPos = 0;
                                    }

                                    if(resData[i].orderamount.icbc > 0){
                                        orderamount_icbc = Number(resData[i].orderamount.icbc);
                                    }else{
                                        orderamount_icbc = 0;
                                    }

                                    if(resData[i].orderamount.wechat > 0){
                                        orderamount_wxpay = Number(resData[i].orderamount.wechat);
                                    }else{
                                        orderamount_wxpay = 0;
                                    }
                                }

                                if(resData[i].orderamount.order_online == 6){ //澳門通
                                    order_online = '澳門通';

                                    if(resData[i].orderamount.macaupass == null){
                                        orderamount_macaupass = Number(resData[i].orderamount.overtime_fee);
                                    }else{
                                        orderamount_macaupass = Number(resData[i].orderamount.overtime_fee + resData[i].orderamount.macaupass);
                                    }

                                    if(Number(resData[i].orderamount.credit + resData[i].orderamount.credit_tw) > 0){
                                        orderamount_credit = Number(resData[i].orderamount.credit + resData[i].orderamount.credit_tw);
                                    }else{
                                        orderamount_credit = 0;
                                    }

                                    if(resData[i].orderamount.cash > 0){
                                        orderamount_cash = Number(resData[i].orderamount.cash);
                                    }else{
                                        orderamount_cash = 0;
                                    }

                                    if(resData[i].orderamount.alipay > 0){
                                        orderamount_alipay = Number(resData[i].orderamount.alipay);
                                    }else{
                                        orderamount_alipay = 0;
                                    }

                                    if(resData[i].orderamount.mpay > 0){
                                        orderamount_mpay = Number(resData[i].orderamount.mpay);
                                    }else{
                                        orderamount_mpay = 0;
                                    }

                                    if(resData[i].orderamount.boc > 0){
                                        orderamount_zyPos = Number(resData[i].orderamount.boc);
                                    }else{
                                        orderamount_zyPos = 0;
                                    }

                                    if(resData[i].orderamount.icbc > 0){
                                        orderamount_icbc = Number(resData[i].orderamount.icbc);
                                    }else{
                                        orderamount_icbc = 0;
                                    }

                                    if(resData[i].orderamount.wechat > 0){
                                        orderamount_wxpay = Number(resData[i].orderamount.wechat);
                                    }else{
                                        orderamount_wxpay = 0;
                                    }
                                }

                                if(resData[i].orderamount.order_online == 7){ //Alipay

                                    order_online = '支付寶';

                                    if(resData[i].orderamount.alipay == null)
                                    {
                                        orderamount_alipay = Number(resData[i].orderamount.overtime_fee);
                                    }
                                    else
                                    {
                                        orderamount_alipay = Number(resData[i].orderamount.overtime_fee + resData[i].orderamount.alipay);
                                    }

                                    if(Number(resData[i].orderamount.credit + resData[i].orderamount.credit_tw) > 0)
                                    {
                                        orderamount_credit = Number(resData[i].orderamount.credit) + Number(resData[i].orderamount.credit_tw);
                                    }
                                    else
                                    {
                                        orderamount_credit = 0;
                                    }

                                    if(resData[i].orderamount.cash > 0)
                                    {
                                        orderamount_cash = Number(resData[i].orderamount.cash);
                                    }
                                    else
                                    {
                                        orderamount_cash = 0;
                                    }

                                    if(resData[i].orderamount.macaupay > 0)
                                    {
                                        orderamount_macaupass = Number(resData[i].orderamount.macaupay);
                                    }
                                    else
                                    {
                                        orderamount_macaupass = 0;
                                    }

                                    if(resData[i].orderamount.mpay > 0)
                                    {
                                        orderamount_mpay = Number(resData[i].orderamount.mpay);
                                    }
                                    else
                                    {
                                        orderamount_mpay = 0;
                                    }
                                    
                                    if(resData[i].orderamount.boc > 0)
                                    {
                                        orderamount_zyPos = Number(resData[i].orderamount.boc);
                                    }
                                    else
                                    {
                                        orderamount_zyPos = 0;
                                    }
                                     
                                    if(resData[i].orderamount.icbc > 0)
                                    {
                                        orderamount_icbc = Number(resData[i].orderamount.icbc);
                                    }
                                    else
                                    {
                                        orderamount_icbc = 0;
                                    }
                                     
                                    if(resData[i].orderamount.wechat > 0)
                                    {
                                        orderamount_wxpay = Number(resData[i].orderamount.wechat);
                                    }
                                    else
                                    {
                                        orderamount_wxpay = 0;
                                    }
                                }

                                if(resData[i].orderamount.order_online == 8){ //現金

                                    order_online = '現金';

                                    orderamount_cash = Number(resData[i].orderamount.overtime_fee + resData[i].orderamount.cash);
                                    
                                    if(Number(resData[i].orderamount.credit + resData[i].orderamount.credit_tw) > 0){
                                        orderamount_credit = Number(resData[i].orderamount.credit) + Number(resData[i].orderamount.credit_tw);
                                    }else{
                                        orderamount_credit = 0;
                                    }

                                    if(resData[i].orderamount.alipay > 0){
                                        orderamount_alipay = Number(resData[i].orderamount.alipay);
                                    }else{
                                        orderamount_alipay = 0;
                                    }

                                    if(resData[i].orderamount.macaupay > 0){
                                        orderamount_macaupass = Number(resData[i].orderamount.macaupay);
                                    }else{
                                        orderamount_macaupass = 0;
                                    }

                                    if(resData[i].orderamount.mpay > 0){
                                        orderamount_mpay = Number(resData[i].orderamount.mpay);
                                    }else{
                                        orderamount_mpay = 0;
                                    }

                                    if(resData[i].orderamount.boc > 0){
                                        orderamount_zyPos = Number(resData[i].orderamount.boc);
                                    }else{
                                        orderamount_zyPos = 0;
                                    }

                                    if(resData[i].orderamount.icbc > 0){
                                        orderamount_icbc = Number(resData[i].orderamount.icbc);
                                    }else{
                                        orderamount_icbc = 0;
                                    }

                                    if(resData[i].orderamount.wechat > 0){
                                        orderamount_wxpay = Number(resData[i].orderamount.wechat);
                                    }else{
                                        orderamount_wxpay = 0;
                                    }
                                }

                                if(resData[i].orderamount.order_online == null || resData[i].orderamount.order_online == 0) //NULL
                                {
                                    order_online = '一次';

                                    if(Number(resData[i].orderamount.credit + resData[i].orderamount.credit_tw) > 0){
                                        orderamount_credit = Number(resData[i].orderamount.credit + resData[i].orderamount.credit_tw + resData[i].orderamount.overtime_fee);
                                    }else{
                                        orderamount_credit = 0;
                                    }

                                    if(resData[i].orderamount.cash > 0){
                                        orderamount_cash = Number(resData[i].orderamount.cash + resData[i].orderamount.overtime_fee);
                                    }else{
                                        orderamount_cash = 0;
                                    }

                                    if(resData[i].orderamount.alipay > 0){
                                        orderamount_alipay = Number(resData[i].orderamount.alipay + resData[i].orderamount.overtime_fee);
                                    }else{
                                        orderamount_alipay = 0;
                                    }

                                    if(resData[i].orderamount.macaupay > 0){
                                        orderamount_macaupass = Number(resData[i].orderamount.macaupay + resData[i].orderamount.overtime_fee);
                                    }else{
                                        orderamount_macaupass = 0;
                                    }

                                    if(resData[i].orderamount.mpay > 0){
                                        orderamount_mpay = Number(resData[i].orderamount.mpay + resData[i].orderamount.overtime_fee);
                                    }else{
                                        orderamount_mpay = 0;
                                    }

                                    if(resData[i].orderamount.boc > 0){
                                        orderamount_zyPos = Number(resData[i].orderamount.boc + resData[i].orderamount.overtime_fee);
                                    }else{
                                        orderamount_zyPos = 0;
                                    }

                                    if(resData[i].orderamount.icbc > 0){
                                        orderamount_icbc = Number(resData[i].orderamount.icbc + resData[i].orderamount.overtime_fee);
                                    }else{
                                        orderamount_icbc = 0;
                                    }

                                    if(resData[i].orderamount.wechat > 0){
                                        orderamount_wxpay = Number(resData[i].orderamount.wechat + resData[i].orderamount.overtime_fee);
                                    }else{
                                        orderamount_wxpay = 0;
                                    }
                                }

                                tempArr.push({

                                    id: resData[i].id,
                                    
                                    name: resData[i].recipient_contacts,
                                    
                                    product: resData[i].detailed.name,
                                    
                                    phone: resData[i].recipient_phone,
                                    
                                    orderNo: resData[i].odd_numbers,
                                    
                                    count: resData[i].count,
                                    
                                    weight: resData[i].weight,
                                    
                                    weight2: Math.ceil((resData[i].long * resData[i].wide * resData[i].height)/6000),
                                    
                                    length: resData[i].long,
                                    
                                    width: resData[i].wide,
                                    
                                    height: resData[i].height,

                                    packageType: resData[i].goods_type != null ? resData[i].goods_type.describe : '無',
                                    
                                    address: resData[i].store != null ? resData[i].store.ReceivingName : '無',
                                    
                                    out_time: resData[i].out_time,
                                    
                                    macao_originating_time: resData[i].macao_originating_time,
                                    
                                    arrive_time: resData[i].arrive_time,
                                    
                                    pick_time: resData[i].pick_time,
                                    
                                    in_time: resData[i].in_time,
                                    
                                    macao_originating_out_time: resData[i].macao_originating_out_time,
                                    
                                    fee: Number(resData[i].freight_collect),
                                    
                                    fee2: resData[i].orderamount.additional_fee ? resData[i].orderamount.additional_fee : 0,

                                    amount: Number(resData[i].amount),

                                    outtimepay: resData[i].orderamount.overtime_fee ? resData[i].orderamount.overtime_fee : 0,

                                    activity: resData[i].store != null ? '-' + resData[i].store.activity : 0, // 立減3元

                                    totalFee: resData[i].orderamount.allamount ? resData[i].orderamount.allamount : 0,

                                    additional_fee: orderamount_additional_fee, // 附加費
                                    
                                    userIntegral: orderamount_credit, //已簽收-積分
                                    
                                    cash: orderamount_cash, //已簽收-現金
                                    
                                    Alipay: orderamount_alipay, //已簽收-支付寶
                                    
                                    MacauPass: orderamount_macaupass, //已簽收-澳門通
                                    
                                    MacauWallet: orderamount_mpay, //已簽收-澳門錢包
                                    
                                    zyPos: orderamount_zyPos, //已簽收-中銀
                                    
                                    icbc: orderamount_icbc, //已簽收-工銀
                                    
                                    wxpay: orderamount_wxpay, //已簽收-微信

                                    remarks: resData[i].remarks,

                                    pay_status: resData[i].pay_status == 0 ? '待付':'已付'
                                });
                            }
                            else
                            {
                                tempArr.push({

                                    id: resData[i].id,
                                    
                                    name: resData[i].recipient_contacts,
                                    
                                    product: resData[i].detailed.name,
                                    
                                    phone: resData[i].recipient_phone,
                                    
                                    orderNo: resData[i].odd_numbers,
                                    
                                    count: resData[i].count,
                                    
                                    weight: resData[i].weight,
                                    
                                    weight2: Math.ceil((resData[i].long * resData[i].wide * resData[i].height)/6000),
                                    
                                    length: resData[i].long,
                                    
                                    width: resData[i].wide,
                                    
                                    height: resData[i].height,
                                    
                                    packageType: resData[i].goods_type != null ? resData[i].goods_type.describe : '無',
                                    
                                    address: resData[i].store != null ? resData[i].store.ReceivingName : '無',
                                    
                                    out_time: resData[i].out_time,
                                    
                                    macao_originating_time: resData[i].macao_originating_time,
                                    
                                    arrive_time: resData[i].arrive_time,
                                    
                                    pick_time: resData[i].pick_time,
                                    
                                    in_time: resData[i].in_time,
                                    
                                    macao_originating_out_time: resData[i].macao_originating_out_time,
                                    
                                    fee: resData[i].freight_collect,
                                    
                                    fee2: resData[i].surcharge_price,
                                    
                                    cash: resData[i].cash ? resData[i].cash : 0,
                                    
                                    userIntegral: resData[i].credit ? resData[i].credit : 0,
                                    
                                    amount: resData[i].amount ? resData[i].amount : 0,
                                    
                                    totalFee: resData[i].activity_pay == null ? Math.round(parseInt(resData[i].freight_collect ? resData[i].freight_collect : 0) + parseInt(resData[i].amount ? resData[i].amount : 0) + parseInt(resData[i].surcharge_price ? resData[i].surcharge_price : 0) + parseInt(resData[i].outtimepay ? resData[i].outtimepay : 0)) : resData[i].activity_pay,

                                    Alipay: resData[i].alipay ? resData[i].alipay : 0,
                                    
                                    MacauPass: resData[i].macaupass ? resData[i].macaupass : 0,
                                    
                                    MacauWallet: resData[i].mpay ? resData[i].mpay : 0,
                                    
                                    zyPos: resData[i].zyPos ? resData[i].zyPos : 0,
                                    
                                    icbc: resData[i].icbc ? resData[i].icbc : 0,    
                                    
                                    outtimepay: resData[i].outtimepay ? resData[i].outtimepay : 0,
                                    
                                    // activity_pay: resData[i].activity_pay ? resData[i].activity_pay : 0,
                                    
                                    activity: resData[i].store != null ? '-' + resData[i].store.activity : 0, // 立減3元
                                    
                                    wxpay: resData[i].wxpay ? resData[i].wxpay : 0,
                                    
                                    remarks: resData[i].remarks,
                                    
                                    pay_status: resData[i].pay_status == 0 ? '待付':'已付'
                                });
                            }
                        }
                        this.totalCount = res.data.count;
            			this.sum = Math.round(res.data.sum);
            			this.money = Math.round(res.data.money);
                        this.table.data = tempArr;
                    }
                }).catch((err) => {
					this.isSubmiting = false;
                    // this.isLoading = false;
                });
            },
            handleSearch() {
                this.pageIndex = 1;
                this.getList();
            },
            handleExport() {
                let token = localStorage.getItem('jyb_token');
                let form = this.form;
                let params = {
                    'Authorization': token,
            		flag: 2,
                    status: -3,  //0待出库, 1已出库
                    arrive: form.arrive,
                    arrive_type: form.arrive_type,
                    goods_type: form.goods_type,
                    start_time: this.formatDate(form.start_time),
                    end_time: this.formatDate(form.end_time),
                    recipient_contacts: form.recipient_contacts,
                    phone: form.phone,
                    odd_numbers: form.odd_numbers,
                    sack_number: form.sack_number,
            		admin_id: form.admin_id
                };
                let formatParams = this.$Utils.formateObjToParamStr(params);
				// window.open(`${this.$Api.deliverFexport}?${formatParams}`, '_blank');
				if(form.start_time == ''){
					this.$Utils.showTipInfo("請選擇起始時間");
				}
				else if(form.end_time == ''){
					this.$Utils.showTipInfo("請選擇结束時間");
				}
				else{
                    this.getList();
					window.open(`${this.$Api.deliverFexport}?${formatParams}`, '_blank');
					// this.exportLink = `${this.$Api.deliverFexport}?${formatParams}`;
				}
                // this.exportLink = `${this.$Api.deliverFexport}?${formatParams}`;
            },
            handlePageSizeChange(value) {
                this.pageIndex = 1;
                this.getList();
            },
            handlePageInput() {
                let value = ('' + this.pageInput).replace(/\D/g, '');
                let pageCount = Math.ceil(this.totalCount / this.curPageSize);
                if (value > pageCount) {
                    value = pageCount;
                }
                this.pageInput = value;
            },
            handlePageEnter() {
                if (this.pageInput == '' || this.pageInput == this.pageIndex) return;
                if (this.pageInput == 0) {
                    this.pageInput = 1;
                }
                this.pageInput = parseInt(this.pageInput);
                this.pageIndex = this.pageInput;
                this.getList();
            },
            handlePageChange(value) {
                this.pageIndex = value;
                this.getList();
            }
        }
    };
</script>

<style>
    .ivu-table td.demo-table-info-column{
        background-color: #FFEBDE;
        color: #000;
    }
    .ivu-table td.demo-table-info-cell-name {
        background-color: #D6E7FF;
        color: #000;
    }
</style>
<style lang="scss" scoped>
    @import "DeliverDetail.scss";
</style>